import { FC } from 'react'
import { RemoveMediaButton } from 'components/features/pfm/RemoveMediaButton/RemoveMediaButton'
import styles from 'components/features/pfm/Removable/Removable.styl'

type RemovableProps = {
  onRemove: () => void
}
export const Removable: FC<RemovableProps> = ({
  children,
  onRemove,
}) => {
  return (
    <div className={ styles.removable }>
      { children }
      <div className={ styles.button } onClick={ onRemove }>
        <RemoveMediaButton />
      </div>
    </div>
  )
}
